import {
  SET_CONVERSATION_ATTRIBUTES,
  UPDATE_CONVERSATION_ATTRIBUTES,
  CLEAR_CONVERSATION_ATTRIBUTES,
} from '../types';
import { getConversationAPI } from '../../api/conversation';

const state = {
  id: '',
  status: '',
  disableTextArea: false,
  disableSendMessage: false,
  disableAttachments: true,
  handover_button_enabled: false,
  handover_button_text: '',
};

export const getters = {
  getConversationParams: $state => $state,
};

export const actions = {
  getAttributes: async ({ commit }) => {
    try {
      const { data } = await getConversationAPI();
      const { contact_last_seen_at: lastSeen } = data;
      commit(SET_CONVERSATION_ATTRIBUTES, data);
      commit('conversation/setMetaUserLastSeenAt', lastSeen, { root: true });
    } catch (error) {
      // Ignore error
    }
  },
  update({ commit }, data) {
    commit(UPDATE_CONVERSATION_ATTRIBUTES, data);
  },
  clearConversationAttributes: ({ commit }) => {
    commit('CLEAR_CONVERSATION_ATTRIBUTES');
  },
};

export const mutations = {
  [SET_CONVERSATION_ATTRIBUTES]($state, data) {
    $state.id = data.id;
    $state.status = data.status;
    $state.disableTextArea = data.custom_attributes.disable_text_area
      ? data.custom_attributes.disable_text_area !== 'false'
      : $state.disableTextArea;
    // $state.disableSendMessage = data.custom_attributes.disable_send_messages
    //   ? data.custom_attributes.disable_send_messages !== 'false'
    //   : $state.disableSendMessage;
    $state.disableAttachments = data.custom_attributes.disable_attachments
      ? data.custom_attributes.disable_attachments !== 'false'
      : $state.disableAttachments;
    $state.handover_button_enabled = data.handover_button_enabled || false;
    $state.handover_button_text = data.handover_button_text || '';
  },
  [UPDATE_CONVERSATION_ATTRIBUTES]($state, data) {
    if (data.id === $state.id) {
      $state.id = data.id;
      $state.status = data.status;
      if (data.custom_attributes) {
        $state.disableTextArea = data.custom_attributes.disable_text_area
          ? data.custom_attributes.disable_text_area !== 'false'
          : $state.disableTextArea;
        $state.disableSendMessage = data.custom_attributes.disable_send_messages
          ? data.custom_attributes.disable_send_messages !== 'false'
          : $state.disableSendMessage;
        $state.disableAttachments = data.custom_attributes.disable_attachments
          ? data.custom_attributes.disable_attachments !== 'false'
          : $state.disableAttachments;
      }
      if (data.handover_button_enabled !== undefined) {
        $state.handover_button_enabled = data.handover_button_enabled;
      }
      if (data.handover_button_text !== undefined) {
        $state.handover_button_text = data.handover_button_text;
      }
    }
  },
  [CLEAR_CONVERSATION_ATTRIBUTES]($state) {
    $state.id = '';
    $state.status = '';
    $state.disableTextArea = false;
    $state.disableSendMessage = false;
    $state.disableAttachments = true;
    $state.handover_button_enabled = false;
    $state.handover_button_text = '';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
